import { render, staticRenderFns } from "./pass.vue?vue&type=template&id=64bc40e4&scoped=true&"
import script from "./pass.vue?vue&type=script&lang=js&"
export * from "./pass.vue?vue&type=script&lang=js&"
import style0 from "./pass.vue?vue&type=style&index=0&id=64bc40e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bc40e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64bc40e4')) {
      api.createRecord('64bc40e4', component.options)
    } else {
      api.reload('64bc40e4', component.options)
    }
    module.hot.accept("./pass.vue?vue&type=template&id=64bc40e4&scoped=true&", function () {
      api.rerender('64bc40e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/merchantWithdrawal/pass.vue"
export default component.exports